import axios from "axios";
import config from '../../config/config';

const getTileApi = async (categoryName) => {
    const response = await axios.get(`${config.API_BASE_URL}/columns/${categoryName}`);

    return response.data;
}

export default getTileApi;